import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['refuse', 'approve']

  toggleButton(){
    const checkbox = this.element.querySelector("input[type=checkbox]:checked")
    const isChecked = checkbox !== null;
    this.refuseTarget.disabled = !isChecked;
    this.approveTarget.disabled = isChecked;
  }
}
